import { legacy_createStore as createStore, applyMiddleware } from "redux"
import thunkMiddleware from "redux-thunk"
import { composeWithDevTools } from "redux-devtools-extension"
import { AllReducers } from "./reducers"
import { UtilityThunkService } from "./thunk/utility"

const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware));
export const store = createStore(AllReducers, composedEnhancer);
store.dispatch(UtilityThunkService.GetConfig as any);
